import { render } from "./baseselect.vue?vue&type=template&id=0656be06&scoped=true"
import script from "./baseselect.vue?vue&type=script&lang=js"
export * from "./baseselect.vue?vue&type=script&lang=js"

import "./baseselect.vue?vue&type=style&index=0&id=0656be06&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0656be06"]])

export default __exports__